module.exports = "/static/media/attestation_icon.bf05d5cf.svg";